<template>
   <div style="width: 100%; height: 100%;">
      <div class="custom-container">
         <v-card flat>
            <v-card-title class="headline">
               WerkBank Kategorien
            </v-card-title>
         </v-card>
         <v-row>
            <v-col
               cols="12" md="4" sm="12"
               v-for="(category, index) in categories" :key="index"
            >
               <router-link :to="{ name: 'IdeasWorkbenchCategoriesShow', params: { id: category.id}}"
                            class="custom-link" style="height: 100%;">
                  <v-hover v-slot:default="{ hover }">
                     <v-card style="height: 100%;" :elevation="hover ? 16 : 2">
                        <v-system-bar style="height: auto;" color="#f5f5f5" class="px-4">
                           <v-chip color="primary" v-if="category.new_ideas" small>
                              <v-avatar
                                 left
                                 class="primary darken-3"
                              >
                                 {{ category.new_ideas }}
                              </v-avatar>
                              <span v-if="category.new_ideas = 1">neue Idee</span>
                              <span v-else>neue Ideen</span>
                           </v-chip>
                           <v-spacer/>
                           <v-tooltip bottom v-if="!category.is_subscribed">
                              <template v-slot:activator="{ on, attrs }">
                                 <v-btn
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                    icon
                                    @click.prevent="subscribeFeed(category.id)"
                                 >
                                    <v-icon color="primary" class="ma-0">mdi-bell-outline</v-icon>
                                 </v-btn>
                              </template>
                              <span>Benachrichtigungen erhalten</span>
                           </v-tooltip>
                           <v-tooltip bottom v-if="category.is_subscribed">
                              <template v-slot:activator="{ on, attrs }">
                                 <v-btn
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                    icon
                                    @click.prevent="unsubscribeFeed(category.feed_id)"
                                 >
                                    <v-icon color="primary" class="ma-0">mdi-bell</v-icon>
                                 </v-btn>
                              </template>
                              <span>Benachrichtigungen abstellen</span>
                           </v-tooltip>
                        </v-system-bar>
                        <v-card-title>
                           {{ category.name }}
                        </v-card-title>
                        <v-card-subtitle>
                           {{ category.ideas_count }} Idee(n)
                        </v-card-subtitle>
                        <v-card-text>
                           {{ category.description }}
                        </v-card-text>
                     </v-card>
                  </v-hover>
               </router-link>

            </v-col>
         </v-row>
      </div>
   </div>
</template>

<script>
export default {
   props: [],
   name: "",
   data: () => ({
      categories: {},
   }),
   computed: {},
   created() {
      this.getCategories();
   },
   methods: {
      getCategories() {
         this.axios.get('/ideas-categories').then((r) => {
            this.categories = r.data.data;
         })
      },
      subscribeFeed(id) {
         var data = {};
         data.feedable_type = 'ideasCategory';
         data.feedable_id = id;

         this.axios.post('/feeds', {
            'feed': data
         }).then(() => {
            this.$toast.success('Sie erhalten nun Benachrichtigungen der Idee.');
            this.getCategories();
         })
      },

      unsubscribeFeed(id) {
         this.axios.delete('/feeds/' + id).then(() => {
            this.$toast.success('Sie erhalten nun keine Benachrichtigungen der mehr.');
            this.getCategories();
         })
      },
   }
}
</script>

<style scoped>

</style>
